import logo from "./logo.svg";
import "./App.css";
import EditorFrag from "./frag/Editor";

function App() {
  return (
    <div className="App">
      <EditorFrag></EditorFrag>
    </div>
  );
}

export default App;
